import { keyframes } from '@emotion/react';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { Box, CircularProgress, Typography } from '@mui/material';
import { BLUE, GREEN, NAVY, POPPINS, RING_TRACK } from '../studentStyles';

const checkPop = keyframes`
    from { transform: scale(0.6); opacity: 0.4; }
    to { transform: scale(1); opacity: 1; }
`;

interface ProgressRingProps {
    percent: number;
    size?: number;
    thickness?: number;
    showLabel?: boolean;
}

export default function ProgressRing({ percent, size = 32, thickness = 5, showLabel = false }: ProgressRingProps) {

    // Celebration state: solid green disc with a white check
    if (percent >= 100) {
        return (
            <Box role="img" aria-label="100% complete" sx={{
                width: size, height: size, borderRadius: '50%', backgroundColor: GREEN,
                display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
            }}>
                <CheckRoundedIcon sx={{ color: '#fff', fontSize: size * 0.6, animation: `${checkPop} 250ms ease-out`, '@media (prefers-reduced-motion: reduce)': { animation: 'none' } }} />
            </Box>
        );
    }

    return (
        <Box sx={{ position: 'relative', display: 'inline-flex', width: size, height: size, flexShrink: 0, '@media (prefers-reduced-motion: reduce)': { '& *': { transition: 'none !important' } } }}>
            <CircularProgress
                aria-hidden="true"
                variant="determinate"
                value={100}
                size={size}
                thickness={thickness}
                sx={{ color: RING_TRACK, position: 'absolute', left: 0 }}
            />
            <CircularProgress
                aria-label="Progress"
                variant="determinate"
                value={percent}
                size={size}
                thickness={thickness}
                sx={{ color: BLUE, '& .MuiCircularProgress-circle': { strokeLinecap: 'round' } }}
            />
            {showLabel && (
                <Box sx={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Typography sx={{ fontFamily: POPPINS, fontWeight: 600, color: NAVY, fontSize: Math.max(11, size * 0.22) }}>
                        {percent}%
                    </Typography>
                </Box>
            )}
        </Box>
    );
}
